module.exports = __webpack_public_path__ + "img/inverted_color_map.5ed9e525.png";